<template>
	<store-module-injector>
		<MapMain />
	</store-module-injector>
</template>
<script>
import MapMain from './MapSearch/MapMain.vue';
import StoreModuleInjector from './StoreModuleInjector.vue';
export default { components: { StoreModuleInjector, MapMain }, };
</script>
